import { Col } from 'antd'
import React from 'react'
import CloseIcon from '../../../../../../components/icons/CloseIcon'
import { EmptyDivElement } from '../../../../../../components/UIComponents/CommonStyledComponent'
import { isReturnBoolean } from '../../../../../../utils/rolecreationHelpers'
import { Chips, MainQualificationDiv } from '../../../CompanyCard/style'
import { flatMapFunction, getCoursesLabel } from './CommonFunctions'
import {
  AndOrStyle,
  DividerGap,
  QualificationDiv,
  StyledDivider,
} from './Styles'

export default function QualificationSelectionBubble({
  data,
  handleRemoveFilter,
  handleAllRemove,
  checkAllCompleted,
  isShow,
  disabled = false,
}) {
  return (
    isShow && (
      <MainQualificationDiv key={data}>
        <QualificationDiv> Qualification</QualificationDiv>
        {data?.map(({ selected }, index, arr) => {
          return (
            <>
              {Object.entries(selected).map(([key, value]) => {
                return (
                  <>
                    {value?.isAllDegree ? (
                      <Chips key={index + [key]}>
                        <div>{`Any ${getCoursesLabel(key)}`}</div>
                        {!checkAllCompleted && (
                          <EmptyDivElement
                            onClick={() =>
                              handleAllRemove(selected, index, key)
                            }
                          >
                            <CloseIcon width={15} height={15} />
                          </EmptyDivElement>
                        )}
                      </Chips>
                    ) : (
                      flatMapFunction(value?.data).map((item, i) => {
                        const { indices, label } = item
                        return (
                          <Col
                            key={i + 'degreeStreamSpec'}
                            style={{ minHeight: 'unset' }}
                          >
                            <Chips style={{ height: 'fit-content' }}>
                              <div style={{ textTransform: 'capitalize' }}>
                                {label}
                              </div>
                              {!disabled && (
                                <EmptyDivElement
                                  onClick={() => {
                                    handleRemoveFilter(
                                      index,
                                      indices?.field,
                                      false,
                                      indices?.degreeId,
                                      indices?.streamId,
                                      indices?.specialisationId,
                                      indices?.type === 'P.G.DIPLOMA'
                                        ? 'DIPLOMA'
                                        : indices?.type === 'P_G_DIPLOMA'
                                        ? 'DIPLOMA'
                                        : indices?.type
                                    )
                                  }}
                                  style={{ marginTop: 3 }}
                                >
                                  <CloseIcon width={15} height={15} />
                                </EmptyDivElement>
                              )}
                            </Chips>
                          </Col>
                        )
                      })
                    )}
                  </>
                )
              })}
              <AndOrStyle>
                {index < arr?.length - 1 &&
                  Object.entries(data[index + 1]?.selected || {}).some(
                    ([, value]) =>
                      (Array.isArray(value?.data) && value.data.length > 0) ||
                      value?.isAllDegree
                  ) && (
                    <DividerGap>
                      AND
                      <StyledDivider orientation="left" orientationMargin="0" />
                    </DividerGap>
                  )}
              </AndOrStyle>
            </>
          )
        })}
      </MainQualificationDiv>
    )
  )
}
